// src/app/store.js
import { create } from 'zustand';

// Create the store with Zustand
const useAppStore = create((set) => ({
  // Initial state (same as Redux initialState)
  isLoading: false,
  isSubLoading: false,
  user: null,
  userDetails: {},
  updateStatus: false,
  currentUserDetails: {},
  chatUserId: "",
  chatList: [],
  channelList: [],
  favData: [],
  favChannelData: [],
  isActiveChatUserIsFavorite: false,
  channelId: "",
  channelDetails: {},
  pinMessages: [],
  clickflag: false,
  ediID: "",
  editFlag: false,
  replyediID: "",
  replyeditFlag: false,
  profileFlag: false,
  chalListData: [],
  toggle: false,
  isInfoModalVisible: false,
  closeConversationFlag: false,
  timeAgoText: "",
  lastActiveStatus: "",
  searchModal: false,
  serchModalExpand: false,
  searchMsgText: {value:"",timestamp:0},
  searchParticularRecord: {
    id:0,
    name:""
  },
  autoFocus: false,
  jumpConfig: {},
  cancelToken: {cancel:()=>true},
  cancelTokenUserDetails: {cancel:()=>true},
  cancelTokenGetChannelMember: {cancel:()=>true},
  cancelTokenGetChannelById: {cancel:()=>true},
  isFileSendLoading: false,
  allNotificationCount: 2,

  // Actions (equivalent to Redux reducers)
  setLoading: (isLoading) => set({ isLoading }),
  setSubLoading: (isSubLoading) => set({ isSubLoading }),
  setUser: (user) => set({ user }),
  setUserDetails: (userDetails) => set({ userDetails }),
  setCurrnetUserDetails: (currentUserDetails) => set({ currentUserDetails }),
  setUpdateStatus: (updateStatus) => set({ updateStatus }),
  setChatUserId: (chatUserId) => {
    localStorage.setItem("current_id", chatUserId);
    set({ chatUserId });
  },
  setChatList: (chatList) => set({ chatList }),
  setChannelList: (channelList) => set({ channelList }),
  setfavUserData: (favData) => set({ favData }),
  setfavChannelData: (favChannelData) => set({ favChannelData }),
  setChannelId: (channelId) => set({ channelId }),
  setChannelDetails: (channelDetails) => set({ channelDetails }),
  setActiveChatUserFavorite: (isActiveChatUserIsFavorite) => set({ isActiveChatUserIsFavorite }),
  setPinnedMessages: (pinMessages) => set({ pinMessages }),
  setchalListData: (chalListData) => set({ chalListData }),
  setclickflg: (clickflag) => set({ clickflag }),
  seteditId: (ediID) => set({ ediID }),
  seteditFlag: (editFlag) => set({ editFlag }),
  setreplyeditId: (replyediID) => set({ replyediID }),
  setreplyeditFlag: (replyeditFlag) => set({ replyeditFlag }),
  setProfileFlag: (profileFlag) => set({ profileFlag }),
  setToggle: (toggle) => set({ toggle }),
  toggleInfoModalVisibility: () => set((state) => ({ isInfoModalVisible: !state.isInfoModalVisible })),
  setInfoModalVisibility: (isInfoModalVisible) => set({ isInfoModalVisible }),
  setCloseConversationlag: (closeConversationFlag) => set({ closeConversationFlag }),
  setTimeAgoText: (timeAgoText) => set({ timeAgoText }),
  setLastActiveStatus: (lastActiveStatus) => set({ lastActiveStatus }),
  setSearchModal: (searchModal) => set({ searchModal }),
  setSearchModalExpand: (serchModalExpand) => set({ serchModalExpand }),
  setSearchMsgText: (searchMsgText) => set({ searchMsgText }),
  setParticularChannelUserMsg: (searchParticularRecord) => set({ searchParticularRecord }),
  setAutoFocus: (autoFocus) => set({ autoFocus }),
  setJumpConfig: (jumpConfig) => set({ jumpConfig }),
  setCancelToken: (cancelToken) => set({ cancelToken }),
  setCancelTokenUserDetails: (cancelTokenUserDetails) => set({ cancelTokenUserDetails }),
  setCancelTokenGetChannelMember: (cancelTokenGetChannelMember) => set({ cancelTokenGetChannelMember }),
  setCancelTokenGetChannelById: (cancelTokenGetChannelById) => set({ cancelTokenGetChannelById }),
  setIsFileSendLoading: (isFileSendLoading) => set({ isFileSendLoading }),
  setAllNotificationCount: (allNotificationCount) => set({ allNotificationCount }),
  setIsReplyThreadSidebarVisible: (isReplyThreadSidebarVisible) => set({ isReplyThreadSidebarVisible }),

}));

// Selector hooks for accessing specific state pieces
export const useLoading = () => useAppStore((state) => state.isLoading);
export const useSubLoading = () => useAppStore((state) => state.isSubLoading);
export const useUser = () => useAppStore((state) => state.user);
export const useUserDetails = () => useAppStore((state) => state.userDetails);
export const useCurrentUserDetails = () => useAppStore((state) => state.currentUserDetails);
export const useUpdateStatus = () => useAppStore((state) => state.updateStatus);
export const useChatUserId = () => useAppStore((state) => state.chatUserId);
export const useChatList = () => useAppStore((state) => state.chatList);
export const useChannelList = () => useAppStore((state) => state.channelList);
export const useFavData = () => useAppStore((state) => state.favData);
export const useFavChannelData = () => useAppStore((state) => state.favChannelData);
export const useIsActiveChatUserIsFavorite = () => useAppStore((state) => state.isActiveChatUserIsFavorite);
export const useChannelId = () => useAppStore((state) => state.channelId);
export const useChannelDetails = () => useAppStore((state) => state.channelDetails);
export const usePinMessages = () => useAppStore((state) => state.pinMessages);
export const useClickFlag = () => useAppStore((state) => state.clickflag);
export const useEditId = () => useAppStore((state) => state.ediID);
export const useEditFlag = () => useAppStore((state) => state.editFlag);
export const useReplyEditId = () => useAppStore((state) => state.replyediID);
export const useReplyEditFlag = () => useAppStore((state) => state.replyeditFlag);
export const useProfileFlag = () => useAppStore((state) => state.profileFlag);
export const useChalListData = () => useAppStore((state) => state.chalListData);
export const useToggle = () => useAppStore((state) => state.toggle);
export const useInfoModalVisibility = () => useAppStore((state) => state.isInfoModalVisible);
export const useCloseConversationFlag = () => useAppStore((state) => state.closeConversationFlag);
export const useTimeAgoText = () => useAppStore((state) => state.timeAgoText);
export const useLastActiveStatus = () => useAppStore((state) => state.lastActiveStatus);
export const useSearchModal = () => useAppStore((state) => state.searchModal);
export const useSearchModalExpand = () => useAppStore((state) => state.serchModalExpand);
export const useSearchMsgText = () => useAppStore((state) => state.searchMsgText);
export const useSearchParticularRecord = () => useAppStore((state) => state.searchParticularRecord);
export const useAutoFocus = () => useAppStore((state) => state.autoFocus);
export const useJumpConfig = () => useAppStore((state) => state.jumpConfig);
export const useCancelToken = () => useAppStore((state) => state.cancelToken);
export const useCancelTokenUserDetails = () => useAppStore((state) => state.cancelTokenUserDetails);
export const useCancelTokenGetChannelMember = () => useAppStore((state) => state.cancelTokenGetChannelMember);
export const useCancelTokenGetChannelById = () => useAppStore((state) => state.cancelTokenGetChannelById);
export const useIsFileSendLoading = () => useAppStore((state) => state.isFileSendLoading);
export const useAllNotificationCount = () => useAppStore((state) => state.allNotificationCount);
export const useIsReplyThreadSidebarVisible = () => useAppStore((state) => state.isReplyThreadSidebarVisible);

// Hook to get all actions at once
export const useActions = () => {
  const store = useAppStore();
  return {
    setLoading: store.setLoading,
    setSubLoading: store.setSubLoading,
    setUser: store.setUser,
    setUserDetails: store.setUserDetails,
    setCurrnetUserDetails: store.setCurrnetUserDetails,
    setUpdateStatus: store.setUpdateStatus,
    setChatUserId: store.setChatUserId,
    setChatList: store.setChatList,
    setChannelList: store.setChannelList,
    setfavUserData: store.setfavUserData,
    setfavChannelData: store.setfavChannelData,
    setChannelId: store.setChannelId,
    setChannelDetails: store.setChannelDetails,
    setActiveChatUserFavorite: store.setActiveChatUserFavorite,
    setPinnedMessages: store.setPinnedMessages,
    setchalListData: store.setchalListData,
    setclickflg: store.setclickflg,
    seteditId: store.seteditId,
    seteditFlag: store.seteditFlag,
    setreplyeditId: store.setreplyeditId,
    setreplyeditFlag: store.setreplyeditFlag,
    setProfileFlag: store.setProfileFlag,
    setToggle: store.setToggle,
    toggleInfoModalVisibility: store.toggleInfoModalVisibility,
    setInfoModalVisibility: store.setInfoModalVisibility,
    setCloseConversationlag: store.setCloseConversationlag,
    setTimeAgoText: store.setTimeAgoText,
    setLastActiveStatus: store.setLastActiveStatus,
    setSearchModal: store.setSearchModal,
    setSearchModalExpand: store.setSearchModalExpand,
    setSearchMsgText: store.setSearchMsgText,
    setParticularChannelUserMsg: store.setParticularChannelUserMsg,
    setAutoFocus: store.setAutoFocus,
    setJumpConfig: store.setJumpConfig,
    setCancelToken: store.setCancelToken,
    setCancelTokenUserDetails: store.setCancelTokenUserDetails,
    setCancelTokenGetChannelMember: store.setCancelTokenGetChannelMember,
    setCancelTokenGetChannelById: store.setCancelTokenGetChannelById,
    setIsFileSendLoading: store.setIsFileSendLoading,
    setAllNotificationCount: store.setAllNotificationCount,
    setIsReplyThreadSidebarVisible: store.setIsReplyThreadSidebarVisible,
  };
};

// Export individual action creators (Redux-like API)
// These are wrapper functions that will use the store internally
export const setLoading = (payload) => useAppStore.getState().setLoading(payload);
export const setSubLoading = (payload) => useAppStore.getState().setSubLoading(payload);
export const setUser = (payload) => useAppStore.getState().setUser(payload);
export const setUserDetails = (payload) => useAppStore.getState().setUserDetails(payload);
export const setCurrnetUserDetails = (payload) => useAppStore.getState().setCurrnetUserDetails(payload);
export const setUpdateStatus = (payload) => useAppStore.getState().setUpdateStatus(payload);
export const setChatUserId = (payload) => useAppStore.getState().setChatUserId(payload);
export const setChatList = (payload) => useAppStore.getState().setChatList(payload);
export const setChannelList = (payload) => useAppStore.getState().setChannelList(payload);
export const setfavUserData = (payload) => useAppStore.getState().setfavUserData(payload);
export const setfavChannelData = (payload) => useAppStore.getState().setfavChannelData(payload);
export const setChannelId = (payload) => useAppStore.getState().setChannelId(payload);
export const setChannelDetails = (payload) => useAppStore.getState().setChannelDetails(payload);
export const setActiveChatUserFavorite = (payload) => useAppStore.getState().setActiveChatUserFavorite(payload);
export const setPinnedMessages = (payload) => useAppStore.getState().setPinnedMessages(payload);
export const setchalListData = (payload) => useAppStore.getState().setchalListData(payload);
export const setclickflg = (payload) => useAppStore.getState().setclickflg(payload);
export const seteditId = (payload) => useAppStore.getState().seteditId(payload);
export const seteditFlag = (payload) => useAppStore.getState().seteditFlag(payload);
export const setreplyeditId = (payload) => useAppStore.getState().setreplyeditId(payload);
export const setreplyeditFlag = (payload) => useAppStore.getState().setreplyeditFlag(payload);
export const setProfileFlag = (payload) => useAppStore.getState().setProfileFlag(payload);
export const setToggle = (payload) => useAppStore.getState().setToggle(payload);
export const toggleInfoModalVisibility = () => useAppStore.getState().toggleInfoModalVisibility();
export const setInfoModalVisibility = (payload) => useAppStore.getState().setInfoModalVisibility(payload);
export const setCloseConversationlag = (payload) => useAppStore.getState().setCloseConversationlag(payload);
export const setTimeAgoText = (payload) => useAppStore.getState().setTimeAgoText(payload);
export const setLastActiveStatus = (payload) => useAppStore.getState().setLastActiveStatus(payload);
export const setSearchModal = (payload) => useAppStore.getState().setSearchModal(payload);
export const setSearchModalExpand = (payload) => useAppStore.getState().setSearchModalExpand(payload);
export const setSearchMsgText = (payload) => useAppStore.getState().setSearchMsgText(payload);
export const setParticularChannelUserMsg = (payload) => useAppStore.getState().setParticularChannelUserMsg(payload);
export const setAutoFocus = (payload) => useAppStore.getState().setAutoFocus(payload);
export const setJumpConfig = (payload) => useAppStore.getState().setJumpConfig(payload);
export const setCancelToken = (payload) => useAppStore.getState().setCancelToken(payload);
export const setCancelTokenUserDetails = (payload) => useAppStore.getState().setCancelTokenUserDetails(payload);
export const setCancelTokenGetChannelMember = (payload) => useAppStore.getState().setCancelTokenGetChannelMember(payload);
export const setCancelTokenGetChannelById = (payload) => useAppStore.getState().setCancelTokenGetChannelById(payload);
export const setIsFileSendLoading = (payload) => useAppStore.getState().setIsFileSendLoading(payload);
export const setAllNotificationCount = (payload) => useAppStore.getState().setAllNotificationCount(payload);
export const setIsReplyThreadSidebarVisible = (payload) => useAppStore.getState().setIsReplyThreadSidebarVisible(payload);
export default useAppStore;